import styled from '@emotion/styled';

const TableContainer = styled.table`
  width: 100%;
  margin-bottom: 1rem;
  border: 1px solid ${({ theme }) => theme.color.grey03};
`;

const TableHead = styled.thead`
  background-color: ${({ theme }) => theme.color.brand};
`;

const Row = styled.tr`
  height: 3rem;
`;

const ColumnHead = styled.th`
  padding: 0.3125rem 0.625rem;
  font-weight: bold;
  text-align: left;
  color: ${({ theme }) => theme.color.white};
`;

const Cell = styled.td`
  padding: 0.3125rem 0.625rem;
`;

export { Cell, ColumnHead, Row, TableContainer, TableHead };
